import moment from 'moment';

export const formatDateTimeToISO8601UTCTimestamp = (value: moment.Moment | null) =>
    value ? moment(value).utc().format('YYYY-MM-DDTHH:mm:ss[Z]') : null;
